import axios from "axios";
import config from "app/api/axiosConfig";
import { IService } from "app/api/types";

export default (token: string, data: IService) =>
  axios.put(
    `${process.env.REACT_APP_API_HOST}/admin/services`,
    data,
    config(token)
  );
